<div class="form-item" [ngClass]="'form-field-'+fieldSubmission.field.type">
  <div class="field-label">
    <div>
      <strong>{{fieldSubmission.field.label}}</strong>
      <span class="form-ast" [hidden]="!fieldSubmission.field.mandatory"> * </span>
    </div>
  </div>
  <div class="fill-files" [ngClass]="{'invalid-field': !valid && fieldSubmission.field.mandatory }">
    <core-files-upload [contextUrl]="" (response)='onFilesChange($event)' (onUploading)="uploading = $event"></core-files-upload>
  </div>
  <div *ngIf="initialFiles">
    <core-file-uploaded-list-item 
        *ngFor="let iFile of initialFiles"
        [remove]="true" 
        (onRemove)="remove(iFile)" 
        [file]="iFile"
    ></core-file-uploaded-list-item>

  </div>
</div>